import { co2 } from './common';

export default {
  'consumption.co2': `Emissões de ${co2} combinadas`,
  'consumption.energy': 'Consumo de energia em um ciclo de teste combinado',
  'consumption.fuel': 'Consumo de combustível combinado',
  'footnotes.local': '',
  'footnotes.wltp': '',
  'footnotes.nedc':
    'Os números apresentados foram obtidos em conformidade com o processo de medição prescrito. Trata-se de "valores de CO2 do NEDC" correspondentes ao Artigo 2, No. 1, do Regulamento de Implementação (UE) 2017/1153. Os dados de consumo de combustível foram calculados com base nesses valores. O consumo elétrico foi determinado de acordo com a Diretriz 692/2008/EC.',
  'footnotes.emissions.appendix':
    'Para obter mais informações oficiais sobre o consumo de combustível e as emissões de CO2 de novos veículos, entre em contato com o concessionário autorizado Mercedes-Benz de sua preferência.',
  'search.input.label': 'Resultados da sua busca / Código Online do configurador',
  'search.result.buy-online': 'Compre Online',
  'search.results': 'Nenhum resultado encontrado | {count} resultado da busca | {count} resultados da busca',
  'search.results.count': '{count} resultados da busca',
  'search.results.backup': 'Nenhum resultado do termo exato foi encontrado. Veja páginas relacionadas:',
  'search.results.none.summary':
    'Nenhum resultado para esse termo foi encontrado. Por favor, tente novamente com um termo diferente.',
  'search.show-more': 'Exibir mais resultados',
  'search.unavailable': 'A busca não está disponível.',
  'search.result.new': 'Novo',
  'input.placeholder': 'Resultados da sua busca / Código Online do configurador',

  'suggestions.all_search_results': 'Todos os resultados da pesquisa',
  'suggestions.all_search_results_for': 'Mostrar todos os resultados para',
  'suggestions.in': 'em',

  all: 'Todos',
  UCOS: 'Loja online de carros usados',
  PASSENGER_CARS: 'Automóveis',
  VANS: 'Vans',
  NCOS: 'Loja online de carros novos',
  VIDEO: 'Vídeos',
  DEALER_LOCATOR: 'Pesquisa de concessionárias',
  CONFIGURATOR: 'Configurar seu veículo',
  TEST_DRIVE: 'Test Drive',
  VEHICLE_SEARCH: 'Pesquisa de veículos',
  COLLECT: 'Acessórios e colecionáveis',
  CONNECT: 'Loja Mercedes me',

  'search.result.consumption': 'Consumo',
  'watch.video': 'Ver o vídeo',
  'input.recently': 'Pesquisas recentes',
  'input.help.title': 'O que deve procurar?',
  'input.help.text':
    'Pesquise através dos tipos de veículos, modelos, códigos de configuração ou por acessórios, outros produtos e informações',

  'search.result.grid': 'Grade',
  'search.result.list': 'Lista',

  // No results found
  'support.check': 'Verifique se há erros de escrita ou tente novamente com um termo diferente.',
  'support.no.results': 'Não há resultados de pesquisa disponíveis para este termo de pesquisa.',
  'support.no.results.term': 'Nenhum resultado encontrado',
  'support.chat': 'Não consegue encontrar o que procura? Por favor, use o nosso',
  'support.chat.with.us': 'Suporte Online-Chat',

  'search.results.offer': 'Ofertas populares para "{query}":',
};
